<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="复制工单执行结果" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="625px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="70px">
        <el-form-item label="工单编码：" prop="orderNo">
          <el-input size="mini" v-model.trim="form.orderNo" placeholder="请输入需执行的工单编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="分钟数：" prop="timeMine">
          <el-input size="mini" v-model.trim="form.timeMine" type="number" placeholder="请输入分钟数" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  copyResult,
} from "@/api/MaintenanceWorkOrder";
  export default {
    data() {
      return {
        form: {
          orderId: '',
          timeMine: '',
          orderNo: ''
        },
        rules: {
          unitName: [{
            required: true,
            message: '请输入工单编码',
            trigger: 'blur'
          }]
        },
        loadBtn: false
      }
    },
    props: {
      editData: {
        type: Object,
        required: true,
      },
    },
    created() {

    },
    methods: {
      handleBeforeClose(done) {
        this.$emit('cancel')
        done()
      },
      handleCancel() {
        this.$emit('cancel')
      },
      async handleConfirm() {
        this.form.orderId = this.editData.orderId
        if (this.loadBtn) return
        this.$refs['form'].validate(async valid => {
          if (valid) {
            this.loadBtn = true
            const res = await copyResult(this.form)
            if (res.code === 200) {
              this.$message.success('执行成功')
              this.$emit('confirm')
            }
            this.loadBtn = false
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceWorkOrder/components/CopyOrder.vue